export default "__VITE_ASSET__D516APhd__"